import React from "react";

function PersonCard({ person }) {
  const initials = person.display_name
    .split(" ")
    .map(w => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const photoUrl = person.photo_media_id
    ? `/api/clients/${person.client_id || ""}/media/${person.photo_media_id}`
    : null;

  return (
    <div style={styles.card}>
      <div style={{
        ...styles.avatar,
        background: photoUrl ? "transparent" : "var(--color-accent-subtle)",
        border: photoUrl ? "none" : undefined,
      }}>
        {photoUrl
          ? <img src={photoUrl} alt={person.display_name} style={{ display: "block", maxWidth: "100%", maxHeight: "100%", width: "auto", height: "auto", borderRadius: 8 }} />
          : initials
        }
      </div>
      <div style={styles.info}>
        <div style={styles.nameRow}>
          <span style={styles.name}>{person.display_name}</span>
          <span style={styles.relationship}>{person.relationship}</span>
        </div>
        {person.role_in_life && (
          <p style={styles.role}>{person.role_in_life}</p>
        )}
        {person.notes && (
          <p style={styles.notes}>{person.notes}</p>
        )}
      </div>
    </div>
  );
}

export default function PeopleList({ people = [] }) {
  if (!people.length) return null;
  return (
    <div style={styles.list}>
      {people.map(p => <PersonCard key={p.id} person={p} />)}
    </div>
  );
}

const styles = {
  list: { display: "flex", flexDirection: "column", gap: "var(--space-4)" },
  card: {
    background: "var(--color-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "var(--radius-lg)",
    padding: "var(--space-5)",
    display: "flex",
    gap: "var(--space-5)",
    alignItems: "flex-start",
  },
  avatar: {
    width: 128,
    height: 128,
    borderRadius: "var(--radius-md)",
    background: "var(--color-accent-subtle)",
    color: "var(--color-accent)",
    fontSize: "var(--text-xl)",
    fontWeight: "var(--weight-semibold)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    },
  info: { display: "flex", flexDirection: "column", gap: "var(--space-2)" },
  nameRow: { display: "flex", alignItems: "baseline", gap: "var(--space-3)", flexWrap: "wrap" },
  name: { fontSize: "var(--text-base)", fontWeight: "var(--weight-semibold)", color: "var(--color-text-primary)" },
  relationship: { fontSize: "var(--text-sm)", color: "var(--color-text-tertiary)", textTransform: "capitalize" },
  role: { fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", lineHeight: "var(--leading-normal)" },
  notes: { fontSize: "var(--text-sm)", color: "var(--color-text-tertiary)", fontStyle: "italic" },
};
